module.exports = __webpack_public_path__ + "static/media/glow.f06d6299.png";